import React from 'react'

import MultiStepSignup from '../components/Auth/Signup/MultiStepSignup'
// Old signup component kept for reference/fallback if needed
// import Signup from '../components/Auth/Signup/Signup'

const SignupPage = () => {
  return <MultiStepSignup />
}

export default SignupPage
